/**
 * Created by Ning Jiang on 2018-12-14.
 */
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {Thor} from "../Thor";
import {ThorReelBackgroundAreaView} from "./reelbackground/ThorReelBackgroundAreaView";
import {ThorGameModuleConfig} from "../ThorGameModuleConfig";
import {ThorBigWinView} from "../winpresentation/bigwin/ThorBigWinView";

export class ThorReelAreaView extends ReelAreaView{

    public static _reelAreaView:ThorReelAreaView;

    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);
        ThorGameModuleConfig.thorReelBackgroundAreaView = new ThorReelBackgroundAreaView();
        ThorReelAreaView._reelAreaView = this;
    }
}